import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import Currency from './Currency';
import messages from '../../../locale/messages';
import { restrictUrls } from '../../../helpers/adminPrivileges';

function action({ store, intl }) {
    const title = intl.formatMessage(messages.currencyList);

    //From Redux Store
    let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
    let adminPrivileges = store.getState().account && store.getState().account.privileges;
    let privileges = store.getState().commonSettings && store.getState().commonSettings.privileges;


    if (!isAdminAuthenticated) return { redirect: '/login' }
    if (!restrictUrls('/siteadmin/currency', adminPrivileges, privileges)) return { redirect: '/siteadmin' };

    return {
        title,
        component: (
            <AdminLayout>
                <Currency />
            </AdminLayout>
        ),
    }
}

export default action;